import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { WellnessCalendarUtilizationCard } from "../atoms"
import { DefaultWellnessCalendar } from "../../../assets/images"
import { OverviewCalendarEmptyIllustration, OverviewSectionIcon } from '../../overview/OverviewSectionIcon'
import { handleAppError } from "../../handlers"
import { OverviewApi } from "../../../services"
import { CardSlider } from "../molecules"
import { SpinnerDotted } from "../../common/atoms"

const WellnessCalendarCard = ({ contractId, startDate, endDate, classes = '' }) => {
  const [state, setState] = useState({ loading: true })
  const history = useHistory()

  useEffect(() => {
    if (!contractId) return

    setState(prevState => { return { ...prevState, loading: true } })
    OverviewApi.fetchWellnessCalendarOverview({ contract_id: contractId, start_date: startDate, end_date: endDate },
      (res) => {
        setState({ ...res.data, loading: false })
      },
      (err) => handleAppError(err)
    )
  }, [contractId])

  const { sponsored, upcoming_events = [], completed_events = [], loading } = state
  const ongoingEvents = upcoming_events.map((item) => <WellnessCalendarUtilizationCard key={item.name} classes='gap-4 pr-4 m-3 w-90 h-full' svgsrc={item.image ?? DefaultWellnessCalendar} title={item.name} date={item.event_date} time={item.event_time} liner={`${item.total_participants} participants joined`} />)
  const completedEvents = completed_events.map((item) => <WellnessCalendarUtilizationCard key={item.name} classes='gap-4 pr-4 m-3 w-90 h-full' svgsrc={item.image ?? DefaultWellnessCalendar} title={item.name} date={item.event_date} time={item.event_time} liner={`${item.total_participants} participants joined`} />)

  return (
    <div
      className={`rounded-lg border border-gray-250 bg-white py-6 shadow-sm transition-shadow duration-200 hover:shadow-md ${classes}`}
    >
      <div className='flex flex-col gap-4 px-6 sm:flex-row sm:items-center sm:justify-between'>
        <div className='flex items-center gap-3'>
          <OverviewSectionIcon name='wellness_calendar' />
          <div className="flex flex-row gap-4">
            <span className={`text-base font-semibold text-gray-700 leading-none flex gap-4`}>{'Wellness calendar'}</span>
            {sponsored && (
              <span className='-mt-1 inline-block rounded-full bg-green-100 px-2 py-1 text-xs font-medium text-green-700'>Sponsored</span>
            )}
          </div>
        </div>
        <div className='flex flex-wrap gap-2 sm:justify-end'>
          <button
            type='button'
            className='rounded-lg border border-gray-250 bg-white px-4 py-2 text-xs font-semibold text-gray-800 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2'
            onClick={() => '/wellness-calendar/create-event' && history.push('/wellness-calendar/create-event')}
          >
            Create an event
          </button>
          <button
            type='button'
            className='rounded-lg border border-gray-250 bg-white px-4 py-2 text-xs font-semibold text-gray-800 shadow-sm transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2'
            onClick={() => '/wellness-calendar' && history.push('/wellness-calendar')}
          >
            Wellness calendar
          </button>
        </div>
      </div>
      {
        !loading ?
          <>
            {(ongoingEvents.length <= 0 && completedEvents.length <= 0) ?
              <div className='flex flex-col mt-6'>
                <h3 className='px-6 text-xs font-semibold uppercase tracking-wider text-gray-500'>{'UPCOMING/COMPLETED EVENTS'}</h3>
                <div className="flex flex-col items-center">
                  <OverviewCalendarEmptyIllustration className='mx-auto h-28 w-28 text-gray-300' />
                  <h3 className="font-semibold text-base text-gray-700 mb-0">No upcoming/completed events</h3>
                </div>
              </div>
              :
              <div className='gap-6 mt-6'>
                <div className='flex flex-col'>
                  <h3 className='px-6 text-xs font-semibold uppercase tracking-wider text-gray-500'>{'LIVE/UPCOMING EVENTS'}</h3>
                  {ongoingEvents.length > 0 ?
                    <CardSlider classes='px-3' data={ongoingEvents} slidesToShow={3} slidesToScroll={3} />
                    :
                    <h3 className="font-semibold text-base text-gray-700 flex flex-col items-center my-6 mb-0">No live/upcoming events</h3>
                  }
                </div>
                <div className='flex flex-col mt-6'>
                  <h3 className='px-6 text-xs font-semibold uppercase tracking-wider text-gray-500'>{'COMPLETED EVENTS'}</h3>
                  {completedEvents.length > 0 ?
                    <CardSlider classes='px-3' data={completedEvents} slidesToShow={3} slidesToScroll={3} />
                    :
                    <h3 className="font-semibold text-base text-gray-700 flex flex-col items-center my-6 mb-0">No completed events</h3>
                  }
                </div>
              </div>
            }
          </> :
          <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }
    </div>
  )
}

export default WellnessCalendarCard